document.addEventListener("DOMContentLoaded", function() {
  let infiniteScrollEnabled = true;
  let currentPage = 1;
  let loading = false;
  let currNumberOfProducts = 12;
  let currentProductTypes = [];
  let currentProductColors = [];
  const toolbar = document.querySelector('filters-toolbar');
  const collectionHandle = document.querySelector('.grid--view-items').dataset.collectionHandle;

  const initFilters = () => {
    groupProducts();
    updateFilters();
  }

  const updateFilters = () => {
    groupProducts();
    
    const addFilters = (type, container, typeOfFilters) => {
      if (type) {
        const filterId = type.toLowerCase().replace(/\s+/g, '-');
        const filterElement = `
          <div class="filters__checkbox">
            <input type="checkbox" id="${filterId}" name="${typeOfFilters}" value="${type}">
            <label for="${filterId}">${type}</label>
          </div>
        `;
        container.insertAdjacentHTML('beforeend', filterElement);
      }
    }
    
    const filtersContainers = document.querySelectorAll('.filters-type');
    filtersContainers.forEach(container => {
      const typeOfFilters = container.dataset.type;
      container.innerHTML = '';

      typeOfFilters === "type-de-bijoux"
        ? currentProductTypes.forEach(type => { addFilters(type, container, typeOfFilters) })
        : currentProductColors.forEach(type => { addFilters(type, container, typeOfFilters) });
    });

    toolbar.updateData();
  };

  const groupProducts = () => {
    const products = document.querySelectorAll('.product-card');
    products.forEach((product) => {
      productTypes(product);
      productColorMetafields(product);
    });
  }

  const productTypes = (product) => {
    const productType = product.dataset.typeDeBijoux;
    if (productType && !currentProductTypes.includes(productType)) currentProductTypes.push(productType);
  }
    
  const productColorMetafields = (product) => {
    const productColorMetafield = product.dataset.matiere;
    if (productColorMetafield && !currentProductColors.includes(productColorMetafield)) currentProductColors.push(productColorMetafield);
  }

  const loadMoreProducts = () => {
    if (loading) return;
    loading = true;
    currentPage += 1;

    const nextPageURL = `/collections/${collectionHandle}?page=${currentPage}`;
    console.log(nextPageURL);

    fetch(nextPageURL)
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');
        const newProducts = Array.from(doc.querySelectorAll('.product-card')).filter(product => {
          const productGridParent = product.closest('.grid--view-items');
          return productGridParent && productGridParent.dataset.collectionHandle === collectionHandle;
        });

        if (newProducts.length > 0) {
          const productGrid = document.querySelector('.grid--view-items');
          newProducts.forEach(product => {
            const listItem = document.createElement('li');
            listItem.classList.add('grid__item', 'grid__item--collection-template', 'small--one-half', 'medium-up--one-third');
            listItem.appendChild(product);
            productGrid.appendChild(listItem);
          });
          document.getElementById('collProductsFooterLength').textContent = currentPage * 12;
          loading = false;

          updateFilters();
        } else {
          infiniteScrollEnabled = false;
        }
      })
      .catch(error => {
        console.error('Erreur lors du chargement des produits :', error);
        loading = false;
      });
  };

  document.getElementById('collProductsFooterBtn').addEventListener('click', loadMoreProducts);

  initFilters();
});
